import React, { useEffect } from 'react';
import LoginCard from './LoginCard';
import SSOLoginButton from './SSOLoginButton';
import ErrorMessage from '../shared/ErrorMessage';
import { useSSOLogin } from '../../hooks/auth/useSSOLogin';

function Login() {
  const { isLoading, error, initiateSSOLogin, processSSOCallback } = useSSOLogin();

  useEffect(() => {
    // Check if we have code and state parameters (after SSO redirect)
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    
    if (code && state) {
      // Convert URLSearchParams to object for the API call
      const params = {};
      urlParams.forEach((value, key) => {
        params[key] = value;
      });
      
      processSSOCallback(params);
    }
  }, [processSSOCallback]);

  return (
    <>
      {isLoading && (
        <div className="sso-loading-overlay">
          <div className="sso-loading-content">
            <div className="sso-spinner"></div>
            <h2>Authenticating...</h2>
            <p>Please wait while we verify your credentials</p>
          </div>
        </div>
      )}
      
      <LoginCard>
        {error && <ErrorMessage message={error} />}
        
        <SSOLoginButton 
          onClick={initiateSSOLogin}
          isLoading={isLoading}
        />
        
        <div className="login-info">
          <p>Use your corporate credentials to sign in securely</p>
        </div>
      </LoginCard>
    </>
  );
}

export default Login;